import React from 'react';
import CartInputField from './CartInputField';

function CartCheckout(props) {

  return (
    <>
      <div className="checkout_cart">
        {props.loggedIn === false && props.registerOptionOn === true ? (
          <CartInputField
            required={false}
            type="checkbox"
            lbl="Registrami al sito"
            name="CkRegister"
            value={props.registerOption}
            change={props.changeRegisterOption}
            cssClass="registrami_cart"
            labelRight={true}
            url="/register"
            urlText="leggi"
            errList={props.errList}
          />
        ) : null}
        {props.cartData.info_aggiuntive.flag_privacy > 0 ? (
          <CartInputField
            required={true}
            type="checkbox"
            lbl="Ho preso visione e accetto l'informativa sulla Privacy"
            name="CkPrivacy"
            value={props.privacyOption}
            change={props.changePrivacyOption}
            cssClass="privacy_cart"
            labelRight={true}
            //url="/privacy"
            url={props.privacyUrl}
            urlText="leggi"
            errList={props.errList}
          />
        ) : null}
        {props.cartData.info_aggiuntive.flag_condizioni > 0 ? (
          <CartInputField
            required={true}
            type="checkbox"
            lbl="Ho preso visione delle condizioni di vendita"
            name="CkConditions"
            value={props.conditionsOption}
            change={props.changeConditionsOption}
            cssClass="vendita_cart"
            labelRight={true}
            url="/condizioni-vendita"
            urlText="leggi"
            errList={props.errList}
          />
        ) : null}
      </div>

      <div className="riga_bottone_cart">
        <input
          type="button"
          className="bottone_cart"
          onClick={() => props.confirmOrder()}
          value="PROCEDI CON L'ORDINE"
          name="confirmOrder"
        />
      </div>
    </>
  );
}

export default CartCheckout;